export default {
  id: "beyond-books-silver-moon",
  pride: 46080,
  slug: "beyond-books-silver-moon",
  series: "beyond-books",
  category: "novel",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "不止于纸上的故事：银月篇",
    en: "Beyond Books: Silver Moon"
  },
  image: require('@/assets/images/bbs.webp'),
  descriptionKey: {
    zh: "定稿小说（约2万字），信息差、谎言、异能者会战悬疑故事。",
    en: "Finalized novel (~20k words). A suspense story about information gaps, lies, and esper battles."
  },
  date: { year: 2023, month: 6 },
  genres: ["超能力智斗", "都市奇幻", "科幻", "悬疑"],
  themes: ["信息差", "谎言", "异能者会战"],
  scale: {
    zh: "约 20,000 字",
    en: "Approx. 20,000 words"
  },
  developerNotesKey: {
    zh: "小说的读者都是个位数。发布在微信公众号和个人博客。",
    en: "The novel has single-digit readers. Published on WeChat Official Account and personal blog."
  },
  tags: ["小说"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "blog", url: "https://tobenot.top/p/story-bb-silvermoon-director-cut/", textKey: { zh: "博客阅读", en: "Read on Blog" } }
  ]
};
